var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 31,
    viewBox: "0 0 31 31",
    width: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.5 28c6.9036 0 12.5-5.5964 12.5-12.5 0-6.90356-5.5964-12.5-12.5-12.5-6.90356 0-12.5 5.59644-12.5 12.5 0 6.9036 5.59644 12.5 12.5 12.5zm0 3c8.5604 0 15.5-6.9396 15.5-15.5 0-8.56041-6.9396-15.5-15.5-15.5-8.56041 0-15.5 6.93959-15.5 15.5 0 8.5604 6.93959 15.5 15.5 15.5z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.8426 23h-2.6852v-10.7412h2.6852zm-2.8426-13.52085c0-.43018.1327-.78425.3981-1.06221.2717-.27796.6389-.41694 1.1019-.41694.4568 0 .821.13898 1.0926.41694s.4074.63203.4074 1.06221c0 .4368-.1389.79415-.4167 1.07215-.2716.278-.6327.4169-1.0833.4169s-.8148-.1389-1.0926-.4169c-.2716-.278-.4074-.63535-.4074-1.07215z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.e99a435f.svg";
export { ForwardRef as ReactComponent };